export const AttachmentSearchFields = {
  Type: "attachmentType",
  VendorPIC: "vendorPIC",
  AdditionalPICs: "additionalPICs",
  Consignment: "consignment",
  SerialNumber: "serialNumber",
  NVDVersion: "nvdVersion",
  IsComplete: "isComplete",
};

export const AttachmentSearchFieldLabels: Record<string, string> = {
  [AttachmentSearchFields.Type]: "Type: ",
  [AttachmentSearchFields.VendorPIC]: "Vendor PIC: ",
  [AttachmentSearchFields.AdditionalPICs]: "Additional PIC: ",
  [AttachmentSearchFields.Consignment]: "Consignment: ",
  [AttachmentSearchFields.SerialNumber]: "Serial #: ",
  [AttachmentSearchFields.NVDVersion]: "NVD Version: ",
  [AttachmentSearchFields.IsComplete]: "Complete: ",
};

export const AttachmentSearchGroupLabels: Record<string, string> = {
  [AttachmentSearchFields.Type]: "Attachment Type",
  [AttachmentSearchFields.VendorPIC]: "Vendor PICs",
  [AttachmentSearchFields.AdditionalPICs]: "Additional PICs",
  [AttachmentSearchFields.Consignment]: "Consignments",
  [AttachmentSearchFields.SerialNumber]: "Serial Numbers",
  [AttachmentSearchFields.NVDVersion]: "NVD Versions",
  [AttachmentSearchFields.IsComplete]: "Completion Status",
};
